import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { Text } from '@bubble-ui/primitive-text';
import { View } from '@bubble-ui/primitive-view';
import { Typography } from '@bubble-ui/molecule-typography';
import { useTextStyle } from '@bubble-ui/hook-use-text-style';
import { getDisplayName } from '@bubble-ui/util-get-display-name';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { ListItemWrapper } from './helper/ListItemWrapper';
import { Bullet } from './helper/Bullet';
import { defaultComponentTokens } from './defaultComponentTokens';
var getAsInt = value => {
  return value ? typeof value === 'string' ? parseInt(value) : value : undefined;
};
var ListItem = _ref => {
  var _klarnaFont$fontFamil, _ref2, _ref3, _ref4, _klarnaFont$fontWeigh, _ref5, _ref6;
  var {
    addRenderingBox,
    children,
    colorToken = 'list/text-color',
    colorTokenArgs,
    customBullet,
    fontFamily: fontFamilyProp,
    fontSize: fontSizeProp,
    fontWeight: fontWeightProp,
    id,
    index,
    isLast,
    itemSpaceToken = 'list/item-space',
    letterSpacing: letterSpacingProp,
    lineHeight: lineHeightProp,
    noStartPadding = false,
    ordered = false,
    testID,
    textToken = 'list/text-style',
    textTokenArgs,
    UNSAFE_props
  } = _ref;
  var textStyle = useTextStyle({
    addRenderingBox,
    colorToken,
    designTokens: defaultComponentTokens,
    direction: 'ltr',
    colorTokenArgs,
    textToken,
    textTokenArgs,
    fontFamily: fontFamilyProp,
    fontSize: fontSizeProp,
    fontWeight: fontWeightProp,
    letterSpacing: letterSpacingProp,
    lineHeight: lineHeightProp
  });
  var designContext = useDesignContext(defaultComponentTokens);
  var isKlarnaFont = fontFamilyProp && designContext.hasTokenInContext(fontFamilyProp);
  var klarnaFont = isKlarnaFont ? designContext.get(fontFamilyProp) : undefined;
  var fontFamily = (_klarnaFont$fontFamil = klarnaFont === null || klarnaFont === void 0 ? void 0 : klarnaFont.fontFamily) !== null && _klarnaFont$fontFamil !== void 0 ? _klarnaFont$fontFamil : fontFamilyProp;
  var fontSize = (_ref2 = fontSizeProp !== null && fontSizeProp !== void 0 ? fontSizeProp : getAsInt(textStyle.fontSize)) !== null && _ref2 !== void 0 ? _ref2 : 16;
  var fontWeight = (_ref3 = (_ref4 = (_klarnaFont$fontWeigh = klarnaFont === null || klarnaFont === void 0 ? void 0 : klarnaFont.fontWeight) !== null && _klarnaFont$fontWeigh !== void 0 ? _klarnaFont$fontWeigh : fontWeightProp) !== null && _ref4 !== void 0 ? _ref4 : textStyle.fontWeight) !== null && _ref3 !== void 0 ? _ref3 : '400';
  var itemSpaceValue = designContext.get(itemSpaceToken).value();
  var lineHeight = fontSizeProp ? lineHeightProp !== null && lineHeightProp !== void 0 ? lineHeightProp : fontSizeProp * 1.15 : (_ref5 = lineHeightProp !== null && lineHeightProp !== void 0 ? lineHeightProp : getAsInt(textStyle.lineHeight)) !== null && _ref5 !== void 0 ? _ref5 : 18;
  var letterSpacing = (_ref6 = letterSpacingProp !== null && letterSpacingProp !== void 0 ? letterSpacingProp : getAsInt(textStyle.letterSpacing)) !== null && _ref6 !== void 0 ? _ref6 : 0;
  var {
    bulletContainerStyle,
    bulletContainerTextStyle,
    listItemStyle
  } = getDefaultStyleSheet({
    customBullet,
    fontSize,
    isLast,
    itemSpaceValue,
    lineHeight,
    noStartPadding,
    ordered
  });
  var adjustedChildren = [];
  React.Children.toArray(children).forEach(element => {
    if (/*#__PURE__*/React.isValidElement(element) && getDisplayName(element) === 'List') {
      adjustedChildren.push(element);
    } else if (Array.isArray(adjustedChildren === null || adjustedChildren === void 0 ? void 0 : adjustedChildren[adjustedChildren.length - 1])) {
      adjustedChildren[adjustedChildren.length - 1].push(element);
    } else {
      adjustedChildren.push([element]);
    }
  });
  return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(ListItemWrapper, {
    id: id,
    style: listItemStyle,
    testID: testID,
    UNSAFE_props: UNSAFE_props
  }, /*#__PURE__*/React.createElement(View, {
    style: bulletContainerStyle
  }, customBullet ? typeof customBullet === 'number' || typeof customBullet === 'string' ? /*#__PURE__*/React.createElement(Typography, {
    addRenderingBox: addRenderingBox,
    colorToken: colorToken,
    colorTokenArgs: colorTokenArgs,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeight: fontWeight,
    letterSpacing: letterSpacing,
    lineHeight: lineHeight,
    textToken: textToken,
    textTokenArgs: textTokenArgs
  }, customBullet) : customBullet : ordered ? /*#__PURE__*/React.createElement(Text, {
    style: _objectSpread(_objectSpread({}, textStyle), bulletContainerTextStyle)
  }, index, ".") : /*#__PURE__*/React.createElement(Bullet, {
    color: textStyle.color,
    fontSize: fontSize,
    fontWeight: getAsInt(fontWeight)
  })), /*#__PURE__*/React.createElement(View, {
    style: {
      flexShrink: 1
    }
  }, adjustedChildren.map(element => {
    var _element$props, _element$props2, _element$props3, _element$props4;
    var finalColorToken = (element === null || element === void 0 ? void 0 : (_element$props = element.props) === null || _element$props === void 0 ? void 0 : _element$props.colorToken) || colorToken;
    var finalColorTokenArgs = (element === null || element === void 0 ? void 0 : (_element$props2 = element.props) === null || _element$props2 === void 0 ? void 0 : _element$props2.colorTokenArgs) || colorTokenArgs;
    var finalTextToken = (element === null || element === void 0 ? void 0 : (_element$props3 = element.props) === null || _element$props3 === void 0 ? void 0 : _element$props3.textToken) || textToken;
    var finalTextTokenArgs = (element === null || element === void 0 ? void 0 : (_element$props4 = element.props) === null || _element$props4 === void 0 ? void 0 : _element$props4.textTokenArgs) || textTokenArgs;
    if (Array.isArray(element)) {
      return /*#__PURE__*/React.createElement(Typography, {
        addRenderingBox: addRenderingBox,
        colorToken: colorToken,
        colorTokenArgs: colorTokenArgs,
        fontFamily: fontFamilyProp,
        fontSize: fontSizeProp,
        fontWeight: fontWeightProp,
        key: element.join('_'),
        letterSpacing: letterSpacingProp,
        lineHeight: lineHeightProp,
        textToken: textToken,
        textTokenArgs: textTokenArgs
      }, React.Children.map(element, el => {
        if (/*#__PURE__*/React.isValidElement(el)) {
          return /*#__PURE__*/React.cloneElement(el, _objectSpread(_objectSpread({}, getDisplayName(el) === 'Link' ? {
            fontFamily: fontFamilyProp,
            fontSize: fontSizeProp,
            fontWeight: fontWeightProp,
            letterSpacing: letterSpacingProp,
            lineHeight: lineHeightProp,
            textToken: finalTextToken,
            textTokenArgs: finalTextTokenArgs
          } : ['List', 'Typography'].includes(getDisplayName(el)) ? {
            colorToken: finalColorToken,
            colorTokenArgs: finalColorTokenArgs,
            fontFamily: fontFamilyProp,
            fontSize: fontSizeProp,
            fontWeight: fontWeightProp,
            letterSpacing: letterSpacingProp,
            lineHeight: lineHeightProp,
            textToken: finalTextToken,
            textTokenArgs: finalTextTokenArgs
          } : {}), typeof el.props === 'object' ? el.props : {}));
        }
        return el;
      }));
    }
    return /*#__PURE__*/React.cloneElement(element, ['Link', 'List', 'Typography'].includes(getDisplayName(element)) ? {
      colorToken: finalColorToken,
      colorTokenArgs: finalColorTokenArgs,
      fontFamily,
      fontSize,
      fontWeight,
      letterSpacing,
      lineHeight,
      textToken: finalTextToken,
      textTokenArgs: finalTextTokenArgs
    } : {});
  }))));
};
ListItem.displayName = 'List.Item';
export { ListItem };
//# sourceMappingURL=ListItem.js.map